import { Typography } from '../typography/typography';

type ProgressIndicatorProps = {
  currentStep: number;
  totalSteps: number;
  color?: 'yellow' | 'black';
};

export const ProgressIndicator = ({ currentStep, totalSteps, color = 'yellow' }: ProgressIndicatorProps) => {
  const progress = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className="mb-4">
      <div className="flex justify-between text-sm text-gray-600 mb-2">
        <Typography type="text-sm" className="text-quipli-black-700">
          Step {currentStep + 1} of {totalSteps}
        </Typography>

        <Typography type="text-sm" className="text-quipli-black-700">
          {Math.round(progress)}%
        </Typography>
      </div>
      <div className="w-full bg-grey-200 rounded-full h-2">
        <div
          className={`h-2 rounded-full transition-all duration-300 ${
            color === 'yellow' ? 'bg-quipli-yellow-300' : 'bg-quipli-black-800'
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
